import { Middleware } from '@reduxjs/toolkit';

import { authApi } from '../api/authApi';
import { customersApi } from '../api/customersApi';
import { projectsApi } from '../api/projectsApi';
import { quotesApi } from '../api/quotesApi';
import { servicesApi } from '../api/servicesApi';
import { logout } from '../slices/authSlice';

/**
 * Middleware to reset API caches when authentication state changes.
 * This prevents cross-tenant data leakage across logins.
 */
const resetApis: Middleware = store => next => action => {
  const result = next(action);
  const shouldReset =
    logout.match(action) ||
    authApi.endpoints.login.matchFulfilled(action) ||
    authApi.endpoints.register.matchFulfilled(action);

  if (shouldReset) {
    store.dispatch(servicesApi.util.resetApiState());
    store.dispatch(quotesApi.util.resetApiState());
    store.dispatch(projectsApi.util.resetApiState());
    store.dispatch(customersApi.util.resetApiState());
  }
  return result;
};

export default resetApis;
